import React from "react";
import PropTypes from "prop-types";
import { Field, reduxForm } from "redux-form";
import { withStyles } from "@material-ui/core/styles";
import MaterialField from "components/shared/ui/Field/MaterialField";
import validate from "validation/Activity/insessEventValidation";
import InputAdornment from "@material-ui/core/InputAdornment";
import * as InSessDataTypes from "constants/InSessDataTypes";
import SelectField from "components/shared/ui/Field/SelectField";
import TimeInput from "./TimeInput";

const styles = theme => ({
  submitButton: {
    width: "100%",
    marginTop: theme.spacing.unit * 2,
  },
  clearButton: {
    width: "100%",
    marginTop: theme.spacing.unit * 2,
  },
  materialField: {
    marginBottom: theme.spacing.unit * 2,
    width: "100%",
    display: "block",
  },
  disabledClearButton: {
    color: "inherit !important",
    backgroundColor: "white !important",
  },
  dateInput: {
    width: "100%",
  },
  dateIcon: {
    paddingBottom: "3px", // IE hack :(
  },
  input: {
    width: "100%",
  },
});

const InsessReduxForm = ({ handleSubmit, classes, type }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="insessEventResult"
        component={MaterialField}
        inputComponent={
          type !== InSessDataTypes.TEN_METER_WALK ? null : TimeInput
        }
        label="Result"
        className={classes.materialField}
        inputClassName={classes.input}
        endAdornment={
          type !== InSessDataTypes.TEN_METER_WALK ? (
            <InputAdornment position="end">m</InputAdornment>
          ) : null
        }
      />
      <Field
        name="insessSpeedMode"
        component={SelectField}
        label="Speed Setting"
        className={classes.materialField}
        inputClassName={classes.input}
        menuItems={[
          { value: "0", label: "Self-Selected" },
          { value: "1", label: "Fastest" },
        ]}
      />
    </form>
  );
};

InsessReduxForm.propTypes = {
  handleSubmit: PropTypes.func,
  classes: PropTypes.object,
  type: PropTypes.string,
};

export default reduxForm({
  form: "insessReduxForm",
  validate,
})(withStyles(styles)(InsessReduxForm));
